import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CImage,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import moment from "moment";
import React from "react";

const ReportHistoryModal = ({ visible, onClose, data }) => {
  console.log(data);
  return (
    <CModal backdrop="static" visible={visible} onClose={onClose}>
      <CModalHeader onClose={onClose}>
        <CModalTitle>Report History</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CRow
          sm={{
            gutterY: 4,
          }}
        >
          {data && data.length > 0 ? (
            data.map((report) => (
              <CCol key={report._id} sm={12}>
                <CCard>
                  <CCardHeader className="d-flex gap-2 align-items-start">
                    <CImage
                      src={report.createdById.avatar}
                      alt={null}
                      width={35}
                      height={35}
                    />
                    <div>
                      <h6 className="mb-1">
                        {report.createdById.firstName}{" "}
                        {report.createdById.lastName}
                      </h6>
                      <div>
                        {moment(report.createdAt).format(
                          "MMMM D, YYYY h:mm:ss A"
                        )}
                      </div>
                    </div>
                  </CCardHeader>
                  <CCardBody>
                    <p component="p">{report.message}</p>
                    <p component="small" className="text-muted">
                      Status: {report.reportStatus}
                    </p>
                  </CCardBody>
                </CCard>
              </CCol>
            ))
          ) : (
            <div className="text-center">No data</div>
          )}
        </CRow>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Close
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default ReportHistoryModal;
